import React from 'react';
import { motion } from 'framer-motion';
import { FileText, Globe, PenLine } from 'lucide-react';

const services = [
  {
    icon: FileText,
    title: "CV Edit & Optimization",
    description: "Professional CV rewriting and ATS optimization, crafted to get you past automated screening and onto hiring managers desks. We can even tailor it if you want to pivot to a new career.",
    color: "from-blue-500 to-indigo-500"
  },
  {
    icon: Globe,
    title: "Strategic Job Applications",
    description: "We create a dedicated Gmail account for you and apply on your behalf. We use targeted applications across local and international markets tailored to your profile.",
    color: "from-violet-500 to-purple-500"
  },
  {
    icon: PenLine,
    title: "Tailored Cover Letters",
    description: "Compelling, role-specific cover letters written to complement your CV and make you stand out from the competition.",
    color: "from-amber-500 to-orange-500"
  }
];

const Services = () => {
  return (
    <section id="services" className="py-24 bg-slate-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="text-center max-w-3xl mx-auto mb-16"
        >
          <h2 className="text-4xl font-bold text-slate-900 mb-4">Everything You Need to Win</h2>
          <p className="text-xl text-slate-600">
            From CV optimization to strategic applications, we handle every step of your job search journey.
          </p>
        </motion.div>

        <div className="grid md:grid-cols-3 gap-8">
          {services.map((service, idx) => (
            <motion.div
              key={service.title}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: idx * 0.2 }}
              whileHover={{ y: -10 }}
              className="bg-white rounded-3xl p-8 shadow-lg shadow-slate-200/50 border border-slate-100 group cursor-pointer"
            >
              <div className={`w-14 h-14 rounded-2xl bg-gradient-to-br ${service.color} flex items-center justify-center mb-6 group-hover:scale-110 transition-transform shadow-lg`}>
                <service.icon className="w-7 h-7 text-white" />
              </div>
              <h3 className="text-xl font-bold text-slate-900 mb-3">{service.title}</h3>
              <p className="text-slate-600 leading-relaxed">{service.description}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Services;
